export default __webpack_public_path__ + "static/media/logo-animation.5cce2b23.webm";